// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { GridItemProps } from "@insite/mobius/GridItem";
import xOrderInformationStyles from "@pace/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { mergeWithCss } from "@pace/XDL/Utilities";
import { css } from "styled-components";

const gridSharedStyle: GridItemProps = {
    width: [12, 6, 6, 6, 6],
    css: css`
        margin-bottom: 4px;
        flex-direction: row;
    `,
};

orderInformationStyles.orderInformationGridContainer = {
    gap: 20,
    css: css`
        margin-bottom: 13px;
    `,
};

orderInformationStyles.mainInformationGridContainer = {
    gap: 5,
};

orderInformationStyles.mainInformationGridItem = {
    width: 12,
};

orderInformationStyles.orderNumberTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.orderDateTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.poNumberTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.statusTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.orderNumberText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.poNumberText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.statusText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderNumberGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.orderDateGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.poNumberGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.statusGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.notesGridItem = {
    ...gridSharedStyle,
    width: 12,
};

orderInformationStyles.notesTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.notesDescription = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderApprovalDetailsShippingInformation = {
    shippingInformationTitle: {
        ...xOrderInformationStyles.address?.informationTitle,
    },
    shippingAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
    shippingInformationCarrierGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingInformationDateRequestedGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingInformationServiceGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingCarrierTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingCarrierText: {
        ...xOrderInformationStyles.value,
    },
    shippingDateRequestedTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingDateRequestedText: {
        ...xOrderInformationStyles.value,
    },
    shippingServiceTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingServiceText: {
        ...xOrderInformationStyles.value,
    },
    shippingInformationGridContainer: {
        gap: 0,
    },
    shippingOtherInformationGridContainer: {
        gap: 0,
    },
    shippingInformationAddressGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    shippingOtherInformationGridItem: {
        width: [12, 6, 6, 6, 6],
    },
};

orderInformationStyles.orderApprovalDetailsBillingInformation = {
    billingInformationGridContainer: {
        gap: 0,
    },
    billingInformationTitle: {
        ...xOrderInformationStyles.address?.informationTitle,
    },
    billingAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
    billingCreditCardAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
};
